<template>
  <div class="listings">
    <nav-bar/>
    <div class="page-header">
      <h1>Tasklist</h1>
      <p>
        Selesaikan persoalan-persoalan yang disediakan oleh Blocode.<br>
        Dapatkan ekstra <b><small>XP</small></b> untuk persoalan yang lebih sulit!
      </p>
    </div>
    <div class="grid-container">
      <tabs :options="{ useUrlFragment: false }" cache-lifetime="60">
        <button class="btn btn--tab filter-button" :class="{'btn--light-blue': !isDefaultSorting}" @click="toggleFilter">
          <i class="fas fa-sort-amount-down-alt m-icon-right"/>
          Pengurutan
          <span v-if="!isDefaultSorting"> aktif</span>
          <i class="fas fa-angle-down m-icon-left" v-if="!filterOpen"/>
          <i class="fas fa-angle-up m-icon-left" v-else/>
        </button>
        <transition name="slide-top">
          <div class="flyout filter-flyout" v-if="filterOpen" v-on-clickaway="toggleFilter">
            <small class="mb-1">Urutkan berdasarkan</small>
            <select v-model="sortType">
              <option value="num">Nomor</option>
              <option value="xp">XP</option>
              <option value="diff">Tingkat kesulitan</option>
            </select>
            <i class="fas fa-angle-down"/>
            <small class="my-1">Urutkan secara</small>
            <select v-model="ordering">
              <option value="asc">Menaik (terkecil di atas)</option>
              <option value="desc">Menurun (terbesar di atas)</option>
            </select>
            <i class="fas fa-angle-down"/>
            <div class="flex jt-flex-end mt-1">
              <button class="btn btn--tab" :class="{'btn--disabled': isDefaultSorting}" @click="resetFilter">
                Atur ulang ke default
              </button>
            </div>
          </div>
        </transition>
        <tab name="Single Task" :class="{'filter-open': filterOpen}">
          <transition-group>
            <div class="single-item" v-for="item in filteredTask" :key="item.id">
              <div class="flex align-items-center">
                <div class="id-field">
                  <small>No.</small><br>
                  {{paddingZero(item.id)}}
                </div>
                <div class="description-field">
                  <b>{{item.name}}</b>
                  <p>{{item.description}}</p>
                </div>
              </div>
              <div class="flex align-items-center flex-no-shrink jt-flex-end ml-2">
                <div class="text-end">
                  <small>Rekorku</small><br>
                  <b>{{(taskScore[item.id] ? taskScore[item.id].score.toFixed(2)+'%' : '---') }}</b>
                </div>
                <div class="text-end ml-2">
                  <div>
                    <i class="fas fa-star" v-for="i in item.difficulty" :key="i + 'star'"></i>
                    <i class="far fa-star" v-for="i in (5 - item.difficulty)" :key="i + 'star-hollow'"></i>
                  </div>
                  <b>{{item.xp}}</b><small>XP</small>
                </div>
                <router-link class="btn btn--tab btn--blue ml-2" :to="{ name: 'taskActivity', params: { id: item.id } }">
                  Mulai!
                </router-link>
              </div>
            </div>
          </transition-group>
        </tab>
        <tab name="Quest" :class="{'filter-open': filterOpen}">
          <transition-group name="list">
            <div class="quest-item" v-for="item in filteredQuest" :key="item.id">
              <div class="flex align-items-center space-between w-100">
                <div class="flex align-items-center w-100">
                  <div class="id-field">
                    <small>Quest</small><br>
                    {{paddingZero(item.id)}}
                  </div>
                  <div class="description-field w-100">
                    <b>{{item.name}}</b>
                    <p>{{item.description}}</p>
                    <hr>
                    <div v-for="subItem in item.subQuest" :key="subItem.id" class="flex space-between">
                      <p><span class="bold text-tabular-number">{{subItem.id}}. </span>{{subItem.name}}</p>
                      <div>
                        <div>
                          <i class="fas fa-star" v-for="i in subItem.difficulty" :key="i + 'star'"></i>
                          <i class="far fa-star" v-for="i in (5 - subItem.difficulty)" :key="i + 'star-hollow'"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex align-items-center flex-no-shrink jt-flex-end ml-2">
                  <div class="text-end">
                    <small>Rekorku</small><br>
                    <b>{{(questScore[item.id] ? questScore[item.id].score.toFixed(2)+'%' : '---') }}</b>
                  </div>
                  <div class="text-end ml-2">
                    <b>{{item.xp}}</b><small>XP</small>
                  </div>
                  <router-link class="btn btn--tab btn--blue ml-2" :to="{ name: 'questActivity', params: { id: item.id } }">
                    Mulai!
                  </router-link>
                </div>
              </div>
              <div>
              </div>
            </div>
          </transition-group>
        </tab>
      </tabs>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import FooterBar from '@/components/FooterBar'
  import {Tabs, Tab} from 'vue-tabs-component'
  import { mixin as clickaway } from 'vue-clickaway'
  import {paddingZero} from '@/utilities/number'
  import TaskStructure from './TasklistPayload/TaskStructure'
  import QuestStructure from './TasklistPayload/QuestStructure'

  export default {
    name: 'listings',
    mixins: [ clickaway ],
    components: {
      NavBar,
      FooterBar,
      Tabs,
      Tab
    },
    data() {
      return {
        sortType: 'num',
        ordering: 'asc',
        taskScore: [],
        questScore: [],
        filterOpen: false,
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
      isDefaultSorting() {
        return this.sortType === 'num' && this.ordering === 'asc'
      },
      filteredTask() {
        if (this.sortType === 'num')
          return TaskStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.id - b.id) : (b.id - a.id))
        else if (this.sortType === 'xp')
          return TaskStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.xp - b.xp) : (b.xp - a.xp))
        else
          return TaskStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.difficulty - b.difficulty) : (b.difficulty - a.difficulty))
      },
      filteredQuest() {
        if (this.sortType === 'num')
          return QuestStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.id - b.id) : (b.id - a.id))
        else if (this.sortType === 'xp')
          return QuestStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.xp - b.xp) : (b.xp - a.xp))
        else
          return QuestStructure.slice().sort((a, b) => this.ordering === 'asc' ? (a.difficulty - b.difficulty) : (b.difficulty - a.difficulty))
      }
    },
    created() {
      this.filterFinishedTask()
      this.filterFinishedQuest()
    },
    methods: {
      paddingZero,
      arrayToObject(array, keyField) {
        return array.reduce((obj, item) => {
          obj[item[keyField]] = item
          return obj
        }, {})
      },
      filterFinishedTask() {
        const array = this.userDataStore.finishedTask.filter(item => item.type === 'single')
        this.taskScore = this.arrayToObject(array, 'taskId')
      },
      filterFinishedQuest() {
        const array = this.userDataStore.finishedTask.filter(item => item.type === 'quest')
        this.questScore = this.arrayToObject(array, 'questId')
      },
      toggleFilter() {
        this.filterOpen = !this.filterOpen
      },
      resetFilter() {
        this.sortType = 'num'
        this.ordering = 'asc'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';
  @import 'src/styles/responsive';

  .btn {
    margin-bottom: 5px;
    display: inline-block;
  }

  .far.fa-star {
    color: rgba($gray, 0.3);
  }

  .single-item, .quest-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    color: $gray;
    background-color: rgba(black, 0.025);
    border-radius: 10px;
    transition: transform 0.3s cubic-bezier(.19,1.39,.59,1), opacity 0.1s;

    &:hover {
      color: black;
      background-color: rgba(black, 0.1);
    }

    &:last-of-type {
      margin-bottom: unset;
    }

    b {
      font-size: 1.1rem;
    }

    p {
      font-size: 0.9rem;
    }

    .id-field {
      font-weight: bold;
      font-variant-numeric: tabular-nums;
      margin-right: 1rem;
    }

    @include mobile {
      flex-direction: column;
      align-items: unset;

       & > *:first-of-type {
        margin-bottom: 1rem;
      }
    }
  }


  .quest-item {
    flex-direction: column;
  }

  .filter-button {
    position: absolute;
    top: -2.25rem;
    right: 0;

    @include mobile {
      position: relative;
      top: -0.5rem;
      display: block;
      margin-left: auto;
    }
  }

  .filter-open {
    opacity: 0.3;
    pointer-events: none;
  }

  .filter-flyout {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
    flex-direction: column;
    overflow-y: auto;
    z-index: 10;
    width: 200px;

    @include mobile {
      top: 3rem;
    }

    small {
      display: block;
    }

    select + i.fas {
      float: right;
      margin-top: -24px;
      margin-right: 5px;
      pointer-events: none;
      padding-right: 5px;
      color: gray;
    }
  }

  .dark-mode {
    .single-item, .quest-item {
      background-color: rgba(black, 0.1);
      color: $demi-gray;

      &:hover {
        color: white;
        background-color: rgba(black, 0.2);
      }
    }
  }
</style>
